import queries from '@apis/queries';
import UserApi from '@apis/user/UserApi';
import useToast from '@hooks/ui/useToast';
import useNativeListener from '@hooks/useNativeListener';
import { ErrorResponse } from '@models/error';
import { Permission } from '@models/permission';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import NativeUtil from '@utils/NativeUtil';
import { AxiosError } from 'axios';

function useToggleLocationAgreement() {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: UserApi.toggleLocationAgreement,
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: queries.user.detail._def });
      queryClient.invalidateQueries({ queryKey: queries.shop._def });
    },
    onError(e: AxiosError<ErrorResponse>) {
      toast.error(e.response?.data.message || '알 수 없는 오류가 발생했습니다.');
    },
  });

  useNativeListener('requestPermission', (permission: Permission, result: boolean) => {
    const prev = window.localStorage.getItem('locationAgreement') === 'true';
    if (permission === Permission.LOCATION) {
      const next = !prev && result;
      window.localStorage.setItem('locationAgreement', String(next));
      mutate(next);
    }
  });

  return () => {
    NativeUtil.postMessage('requestPermission', Permission.LOCATION);
  };
}

export default useToggleLocationAgreement;
